import { Compass, Sparkles, SlidersHorizontal, Footprints } from 'lucide-react';
import { ChapterMark, FadeIn } from '../components/eclora/Reveal';

const CARDS = [
    { n: '01', title: 'Faire le point', icon: Compass, text: 'Comprendre où tu en es vraiment et ce que tu veux faire évoluer.' },
    { n: '02', title: 'Imaginer', icon: Sparkles, text: 'Rencontrer ta Future Toi et clarifier la femme que tu veux devenir.' },
    { n: '03', title: 'Aligner', icon: SlidersHorizontal, text: 'Revoir tes habitudes, ton temps et tes priorités.' },
    { n: '04', title: 'Agir', icon: Footprints, text: 'Arrêter de repousser et poser une première action concrète.' },
];

export default function Benefits() {
    return (
        <section className="bg-nude/15 px-6 py-20 sm:px-10 lg:py-32" data-testid="benefits-section">
            <div className="mx-auto max-w-6xl">
                <ChapterMark index="02" label="Le reset" />
                <FadeIn className="text-center">
                    <h2 className="font-serif text-3xl font-medium text-bordeaux sm:text-4xl lg:text-5xl">
                        Pendant 7 jours, tu vas…
                    </h2>
                </FadeIn>

                <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-7">
                    {CARDS.map((card, i) => (
                        <FadeIn key={card.n} delay={0.1 * i}>
                            <div
                                className="group h-full border border-champagne/30 bg-white/70 p-7 backdrop-blur-sm transition-all duration-500 hover:-translate-y-2 hover:border-champagne/70 hover:shadow-[0_25px_50px_-20px_rgba(114,47,55,0.25)]"
                                data-testid={`benefit-card-${card.n}`}
                            >
                                <div className="flex items-start justify-between">
                                    <span className="font-serif text-5xl font-light text-champagne/70 transition-colors duration-500 group-hover:text-champagne">
                                        {card.n}
                                    </span>
                                    <card.icon className="h-5 w-5 text-bordeaux/70 transition-colors duration-500 group-hover:text-bordeaux" strokeWidth={1.5} aria-hidden="true" />
                                </div>
                                <h3 className="mt-6 font-sans text-sm font-medium uppercase tracking-[0.25em] text-bordeaux">
                                    {card.title}
                                </h3>
                                <p className="mt-3 text-sm leading-relaxed text-cacao/85">{card.text}</p>
                            </div>
                        </FadeIn>
                    ))}
                </div>

                <FadeIn delay={0.2} className="mt-14 text-center">
                    <p className="mx-auto max-w-xl text-serifit text-xl leading-relaxed text-cacao sm:text-2xl">
                        Pas besoin de transformer toute ta vie en 7 jours.
                        <br />
                        <span className="text-bordeaux">Tu as simplement besoin de commencer.</span>
                    </p>
                </FadeIn>
            </div>
        </section>
    );
}
